import {
  startConsoleTap,
  startNetworkTap,
  startPointer,
  startSelection,
  startUiEvents,
  type LoggableEvent,
} from '@financialharmony/show-and-tell';

/** Only the app's own backend calls (edge functions and PostgREST) go in the log; analytics and the audio upload stay out (EC28). */
const BACKEND_PATH = /\/(functions|rest)\/v1\//;
const isBackendCall = (url: string) => BACKEND_PATH.test(url);

/** Starts every capture the consultant app records on the voice clock and returns one stop function. */
export function startCaptures(log: (event: LoggableEvent) => void): () => void {
  const stops = [
    startUiEvents({ document, log }),
    startPointer({ document, log }),
    startSelection({ document, window, log }),
    startNetworkTap({ window, log, now: () => performance.now(), shouldRecord: isBackendCall }),
    startConsoleTap({ console, window, log }),
  ];
  return () => stops.forEach((stop) => stop());
}
